/**
 * Ekranda gösterilen sohbetlerin kaydı.
 *
 * Bir yanıt tamamlandığında "okunmadı" işareti, sohbet o an görünür değilse
 * konur. Eskiden görünürlük yalnızca `/chat/:id` yoluyla anlaşılıyordu; dock
 * ile sohbet başka bir sayfada (ör. /fashion/shop) da açık olabildiği için
 * karar artık mount olan StreamingChat'lerin kaydına dayanır.
 *
 * Sayaç tutulur: aynı sohbet iki yüzeyde (nadir) açıksa biri kapanınca
 * diğeri görünür kalmaya devam eder.
 */
const visibleChats = new Map<string, number>();

/** Sohbeti görünür olarak kaydeder; dönen fonksiyon kaydı geri alır. */
export const registerVisibleChat = (chatId: string): (() => void) => {
  visibleChats.set(chatId, (visibleChats.get(chatId) ?? 0) + 1);
  return () => {
    const next = (visibleChats.get(chatId) ?? 1) - 1;
    if (next <= 0) visibleChats.delete(chatId);
    else visibleChats.set(chatId, next);
  };
};

export const isChatVisible = (chatId: string): boolean =>
  visibleChats.has(chatId);
